import { SidebarMenuSkeleton } from "@/components/ui/sidebar/sidebar";
import { Skeleton } from "@/components/ui/skeleton";

export function AppLayoutSkeleton() {
	return (
		<div className="flex h-svh w-full flex-col bg-background">
			<header className="flex h-14 shrink-0 items-center gap-2 border-b px-3">
				<Skeleton className="size-7 rounded-lg" />
				<Skeleton className="size-8 rounded-md" />
				<div className="flex-1" />
				<Skeleton className="h-8 w-16 rounded-md" />
				<Skeleton className="size-8 rounded-full" />
			</header>

			<div className="flex min-h-0 flex-1 max-w-[100vw]">
				<aside className="hidden h-full w-64 shrink-0 border-r md:flex md:flex-col">
					<div className="space-y-2 px-4 py-4">
						<Skeleton className="h-8 w-full rounded-md" />
						<SidebarMenuSkeleton showIcon width="58%" />
						<SidebarMenuSkeleton showIcon width="64%" />
					</div>

					<div className="flex-1 space-y-2 overflow-hidden border-t px-4 py-4">
						<Skeleton className="mb-3 h-4 w-24" />
						<SidebarMenuSkeleton width="86%" />
						<SidebarMenuSkeleton width="74%" />
						<SidebarMenuSkeleton width="68%" />
						<SidebarMenuSkeleton width="79%" />
						<SidebarMenuSkeleton width="61%" />
					</div>
				</aside>

				<main className="min-w-0 flex-1 overflow-hidden">
					<div className="flex h-full flex-col gap-6 overflow-hidden p-6">
						<div className="flex flex-wrap items-start gap-4">
							<div className="min-w-0 flex-1 space-y-2">
								<Skeleton className="h-8 w-48 max-w-full" />
								<Skeleton className="h-4 w-72 max-w-full" />
							</div>
							<Skeleton className="h-9 w-28 rounded-md" />
						</div>

						<div className="grid gap-4 md:grid-cols-3">
							<Skeleton className="h-28 rounded-xl" />
							<Skeleton className="h-28 rounded-xl" />
							<Skeleton className="h-28 rounded-xl" />
						</div>

						<div className="grid min-h-0 flex-1 gap-4 xl:grid-cols-[minmax(0,1.6fr)_minmax(280px,1fr)]">
							<Skeleton className="h-full min-h-[320px] rounded-2xl" />

							<div className="grid gap-4 md:grid-cols-2 xl:grid-cols-1">
								<Skeleton className="h-48 rounded-2xl" />
								<Skeleton className="h-48 rounded-2xl" />
							</div>
						</div>
					</div>
				</main>
			</div>
		</div>
	);
}
